import initialState from './state'

export const SET_GROUPS = (state, groups) => (state.groups = groups)
export const ADD_USERS = (state, { groupname, users }) => {
  state.users = {
    ...state.users,
    [groupname]: users
  }
}

export const RESET = (state) => {
  Object.keys(initialState).forEach(key => {
    state[key] = initialState[key]
  })
}
